import { action } from 'typesafe-actions';

import { DataManagementTile, DoraDataManagementActionTypes } from './types';

export const setSelectedTab = (selectedTab: DataManagementTile | null, reroute = true) => action(DoraDataManagementActionTypes.SET_SELECTED_DORA_MANAGEMENT_TAB, { selectedTab, reroute });
